import { apiClient } from './client';
import { User } from '../../types/api';

export class UserService {
  /**
   * Récupérer la liste de tous les utilisateurs
   */
  async getUsers(): Promise<User[]> {
    return await apiClient.get<User[]>('/users');
  }

  /**
   * Récupérer les utilisateurs du même périmètre (pour les utilisateurs non-admin)
   */
  async getUsersByPerimeter(): Promise<User[]> {
    return await apiClient.get<User[]>('/users/perimeter');
  }

  /**
   * Récupérer un utilisateur par son ID
   */
  async getUser(id: number): Promise<User> {
    return await apiClient.get<User>(`/users/${id}`);
  }

  /**
   * Récupérer les utilisateurs d'une organisation
   */
  async getUsersByOrganisation(organisationId: number): Promise<User[]> {
    return await apiClient.get<User[]>(`/organisations/${organisationId}/users`);
  }

  /**
   * Récupérer l'utilisateur actuel
   */
  async getCurrentUser(): Promise<User> {
    return await apiClient.get<User>('/auth/me');
  }

  /**
   * Mettre à jour un utilisateur (ADMIN/SUPER_ADMIN)
   * Champs supportés: fullName, email, role, organisationId, isActive
   */
  async updateUser(
    id: number,
    updates: Partial<Pick<User, 'fullName' | 'email' | 'role' | 'organisationId' | 'isActive' | 'perimeterId'>>,
  ): Promise<User> {
    return await apiClient.put<User>(`/users/${id}`, updates);
  }

  /**
   * Créer un utilisateur (ADMIN/SUPER_ADMIN)
   */
  async createUser(payload: {
    fullName: string;
    email: string;
    role: string;
    organisationId?: number | null;
    password: string;
  }): Promise<User> {
    return await apiClient.post<User>('/users', payload);
  }
 
  /**
   * Changer le mot de passe d'un utilisateur (ADMIN/SUPER_ADMIN)
   */
  async changePassword(userId: number, newPassword: string): Promise<{ success: boolean; message: string }> {
    return await apiClient.post<{ success: boolean; message: string }>(
      `/users/${userId}/change-password`,
      { newPassword }
    );
  }
}

// Export singleton instance
export const userService = new UserService();